import { render, staticRenderFns } from "./EmailMapping.vue?vue&type=template&id=7339e0d5&scoped=true"
import script from "./EmailMapping.vue?vue&type=script&lang=js"
export * from "./EmailMapping.vue?vue&type=script&lang=js"
import style0 from "./EmailMapping.vue?vue&type=style&index=0&id=7339e0d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7339e0d5",
  null
  
)

export default component.exports